import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { backGroundColorMainScreen } from '../../common/atom/atoms';

const UnseenSection = () => {
  const bg = useAtomValue(backGroundColorMainScreen);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        background: '#F8E8E9',
        borderTopRightRadius: '32px',
        borderBottomRightRadius: '32px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'inline-flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
      >
        <Typography
          sx={{
            alignSelf: 'stretch',
            color: 'black',
            fontSize: '22px',
            fontFamily: 'Inter',
            fontWeight: 700,
            wordWrap: 'break-word',
            mt: 1,
            ml: '4%',
            textAlign: 'left', // ensure it's left-aligned
          }}
        >
          See The Unseen
        </Typography>
        <Typography
          sx={{
            alignSelf: 'stretch',
            color: '#192126',
            fontSize: '12px',
            fontFamily: 'Inter',
            fontWeight: 300,
            ml: '4%',
            wordWrap: 'break-word',
            mb: '3%',
            textAlign: 'left', // ensure it's left-aligned
          }}
        >
          Discover the power of precision with our state-of-the-art
          <br />
          fiber optic lines monitoring system.
        </Typography>
      </Box>
    </Box>
  );
};

export default UnseenSection;
